import React, { useState, useEffect, useRef, useContext } from 'react'
import classnames from 'classnames/bind'
import { useTranslation } from 'next-i18next'
import { isEmpty } from 'lodash-es'
import { useRouter } from 'next/router'

// Components
import LiveRoom from '../LiveRoom'
import Price from '../Price'
import InfiniteScroll from 'react-infinite-scroller'
import Button from '@/components/common/Button'

// Libs
import { useAppDispatch } from '@/redux/hooks'
import { resetCalendarData } from '@/redux/reducers/calendar'

// Methods
import { goToCalendarPage } from '@/methods/goToPage'

// Styles
import styles from './style.module.scss'
const cx = classnames.bind(styles)

// Context
import { liveStreamingPreviewContext } from '@/components/pages/Product/component/ValidProduct'

interface IPros {
  price: number
  originalPrice: number
}

const LiveRoomList = (props: IPros) => {
  const { price, originalPrice } = props
  const router = useRouter()
  const scrollParentRef = useRef<HTMLDivElement | null>(null)
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const { liveRoomListDataInstance } = useContext<any>(liveStreamingPreviewContext)
  const { data: liveRoomList, isFetchingNextPage, fetchNextPage, hasNextPage } = liveRoomListDataInstance
  const [forceRender, setForceRender] = useState(false)
  const [didMount, setDidMount] = useState(false)

  const handleNextpage = () => {
    if (!isFetchingNextPage) {
      fetchNextPage()
    }
  }

  const handleGoToCalendarPage = () => {
    dispatch(resetCalendarData({}))
    goToCalendarPage(router)
  }

  useEffect(() => {
    setDidMount(true)
  }, [])

  useEffect(() => {
    if (didMount && !forceRender && !isEmpty(scrollParentRef.current)) {
      setForceRender((prev: any) => !prev)
    }
  }, [didMount, forceRender, scrollParentRef.current])

  return (
    <div className={cx('live-room-list__wrapper')}>
      <div className={cx('live-room-list')}>
        <div className={cx('live-room-list__header')}>
          <div className={cx('live-room-list__title')}>{t('LiveStreamingPreview_Title')}</div>
          <div className={cx('live-room-list__description')}>{t('Product_Detail_Coupon_Select_Description')}</div>
          {price > 0 && (
            <div className={cx('live-room-list__price')}>
              <Price isMobile price={price} origPrice={originalPrice} />
            </div>
          )}
        </div>

        <div
          ref={(ref: HTMLDivElement | null) => {
            scrollParentRef.current = ref
          }}
          className={cx('live-room-list__content')}
        >
          {!isEmpty(scrollParentRef.current) && (
            <InfiniteScroll
              initialLoad={false}
              getScrollParent={() => scrollParentRef.current}
              loadMore={handleNextpage}
              hasMore={hasNextPage}
              useWindow={false}
            >
              {liveRoomList?.pages.map((item: any, pageIndex: number) => (
                <React.Fragment key={pageIndex}>
                  {item?.roomList?.map((item: any, roomListIndex: number) => (
                    <div
                      key={roomListIndex}
                      className={cx('live-room-list__item-wrapper', {
                        'live-room-list__item-wrapper--isFirst': pageIndex === 0 && roomListIndex === 0,
                      })}
                    >
                      <LiveRoom
                        isSingle
                        roomId={item.roomId}
                        title={item.title}
                        kolName={item.kolName}
                        startTime={item.startTime}
                        liveType={item.liveType}
                        liveSourceType={item.liveSourceType}
                      />
                    </div>
                  ))}
                </React.Fragment>
              ))}
            </InfiniteScroll>
          )}
        </div>
      </div>

      <div className={cx('live-room-list__footer')}>
        <div onClick={handleGoToCalendarPage} className={cx('live-room-list__button-more')}>
          <Button onClick={handleGoToCalendarPage} isOutline theme={'secondary'} size='md'>
            {t('Common_Button_All_Live_Product_Preview')}
          </Button>
        </div>
      </div>
    </div>
  )
}

export default LiveRoomList
